exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll-area[data-v-e9a55460] {\n    position: relative;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n}\n.no-more-unread-messages[data-v-e9a55460] {\n    margin: 80px 50px;\n    text-align: center;\n    font-size: 16px;\n}\n", ""]);

// exports
